import { Sliders } from "../../interfaces/Sliders";

export async function reductionFormula(sliders: Sliders) : Promise<{
  lapTimeReduction: number;
  remainingResources: number;
  f1GarageScore: number;
}> {
  try {

    const budget = 7500000

    if (!sliders) {
      throw new Error("Sliders are required.");
    }

    let lapTimeReduction = 0;
    let spend = 0;

    // Drag Reduction

    const dragReduction = sliders.dragReduction;

    spend = getDollarValue("dragReduction", dragReduction);
    lapTimeReduction += getBubbleLapTimeValue("dragReduction", dragReduction);

    // Airflow Optimization

    const airflowOptimization = sliders.airflowOptimization;

    spend += getDollarValue("airflowOptimization", airflowOptimization);
    lapTimeReduction += getBubbleLapTimeValue("airflowOptimization", airflowOptimization);

    // Front Downforce

    const frontDownforce = sliders.frontDownforce;

    spend += getDollarValue("frontDownforce", frontDownforce);
    lapTimeReduction += getBubbleLapTimeValue("frontDownforce", frontDownforce);

    // Rear Downforce

    const rearDownforce = sliders.rearDownforce;

    spend += getDollarValue("rearDownforce", rearDownforce);
    lapTimeReduction += getBubbleLapTimeValue("rearDownforce", rearDownforce);

    // Floor

    const floor = sliders.floor;

    spend += getDollarValue("floor", floor);
    lapTimeReduction += getBubbleLapTimeValue("floor", floor);

    // Suspension

    const suspension = sliders.suspension;

    spend += getDollarValue("suspension", suspension);
    lapTimeReduction += getBubbleLapTimeValue("suspension", suspension);

    // Engine Reliability

    const engineReliability = sliders.engineReliability;

    spend += getDollarValue("engineReliability", engineReliability);
    lapTimeReduction += getBubbleLapTimeValue("engineReliability", engineReliability);

    // Turbo Reliability

    const turboReliability = sliders.turboReliability;

    spend += getDollarValue("turboReliability", turboReliability);
    lapTimeReduction += getBubbleLapTimeValue("turboReliability", turboReliability);

    // Energy Recovery

    const energyRecovery = sliders.energyRecovery;

    spend += getDollarValue("energyRecovery", energyRecovery);
    lapTimeReduction += getBubbleLapTimeValue("energyRecovery", energyRecovery);

    // Gearbox

    const gearbox = sliders.gearbox;

    spend += getDollarValue("gearbox", gearbox);
    lapTimeReduction += getBubbleLapTimeValue("gearbox", gearbox);

    // Weight Redistribution

    const weightRedistribution = sliders.weightRedistribution;

    spend += getDollarValue("weightRedistribution", weightRedistribution);
    lapTimeReduction += getBubbleLapTimeValue("weightRedistribution", weightRedistribution);

    // Weight Reduction

    const weightReduction = sliders.weightReduction;

    spend += getDollarValue("weightReduction", weightReduction);
    lapTimeReduction += getBubbleLapTimeValue("weightReduction", weightReduction);

    // Software Upgrade

    const softwareUpgrade = sliders.softwareUpgrade;

    spend += getDollarValue("softwareUpgrade", softwareUpgrade);
    lapTimeReduction += getBubbleLapTimeValue("softwareUpgrade", softwareUpgrade);

    // Hardware

    const hardware = sliders.hardware;

    spend += getDollarValue("hardware", hardware);
    lapTimeReduction += getBubbleLapTimeValue("hardware", hardware);

    // Calculate remaining resources

    const remainingResources = budget - spend;

    // Calculate the AWS Drive your Data score

    const maximumLapTimeReduction = 6.5;

    const garageScore = Math.round((lapTimeReduction / maximumLapTimeReduction) * 100);

    // Return the lap time reduction and remaining resources.

    return {
      lapTimeReduction,
      remainingResources,
      f1GarageScore: garageScore
    }
    
  }
  catch(error) {
    throw error;
  }
}

function getDollarValue(
  range_name:
    | "dragReduction"
    | "airflowOptimization"
    | "frontDownforce"
    | "rearDownforce"
    | "floor"
    | "suspension"
    | "engineReliability"
    | "turboReliability"
    | "energyRecovery"
    | "gearbox"
    | "weightRedistribution"
    | "weightReduction"
    | "softwareUpgrade"
    | "hardware",
  value: number
) {
  switch (range_name) {
    case "dragReduction":
      return Math.floor(value ** 3.1);
    case "airflowOptimization":
      return Math.floor(value ** 3.3);
    case "frontDownforce":
      return Math.floor(value ** 3);
    case "rearDownforce":
      return Math.floor(value ** 3);
    case "floor":
      return Math.floor(value ** 2.95);
    case "suspension":
      return Math.floor(value ** 3.3);
    case "engineReliability":
      return Math.floor(value ** 2.98);
    case "turboReliability":
      return Math.floor(value ** 2.87);
    case "energyRecovery":
      return Math.floor(value ** 3.1);
    case "gearbox":
      return Math.floor(value ** 3);
    case "weightRedistribution":
      return Math.floor(value ** 3.1);
    case "weightReduction":
      return Math.floor(value ** 3.1);
    case "softwareUpgrade":
      return Math.floor(value ** 2.95);
    case "hardware":
      return Math.floor(value ** 2.85);
    default:
      return 0; // Default value if range_name is not recognized
  }
}

function getRangeValue(
  range_name:
    | "dragReduction"
    | "airflowOptimization"
    | "frontDownforce"
    | "rearDownforce"
    | "floor"
    | "suspension"
    | "engineReliability"
    | "turboReliability"
    | "energyRecovery"
    | "gearbox"
    | "weightRedistribution"
    | "weightReduction"
    | "softwareUpgrade"
    | "hardware",
  value: number
) {
  switch (range_name) {
    case "dragReduction":
      return Math.floor(value ** (1 / 3.1));
    case "airflowOptimization":
      return Math.floor(value ** (1 / 3.3));
    case "frontDownforce":
      return Math.floor(value ** (1 / 3));
    case "rearDownforce":
      return Math.floor(value ** (1 / 3));
    case "floor":
      return Math.floor(value ** (1 / 2.95));
    case "suspension":
      return Math.floor(value ** (1 / 3.3));
    case "engineReliability":
      return Math.floor(value ** (1 / 2.98));
    case "turboReliability":
      return Math.floor(value ** (1 / 2.87));
    case "energyRecovery":
      return Math.floor(value ** (1 / 3.1));
    case "gearbox":
      return Math.floor(value ** (1 / 3));
    case "weightRedistribution":
      return Math.floor(value ** (1 / 3.1));
    case "weightReduction":
      return Math.floor(value ** (1 / 3.1));
    case "softwareUpgrade":
      return Math.floor(value ** (1 / 2.95));
    case "hardware":
      return Math.floor(value ** (1 / 2.85));
    default:
      return 0; // Default value if range_name is not recognized
  }
}

function getBubbleLapTimeValue(
  range_name:
    | "dragReduction"
    | "airflowOptimization"
    | "frontDownforce"
    | "rearDownforce"
    | "floor"
    | "suspension"
    | "engineReliability"
    | "turboReliability"
    | "energyRecovery"
    | "gearbox"
    | "weightRedistribution"
    | "weightReduction"
    | "softwareUpgrade"
    | "hardware",
  value: number
) {
  switch (range_name) {
    case "dragReduction":
      return ((value / 100) * 0.5)
    case "airflowOptimization":
      return ((value / 100) * 0.8);
    case "frontDownforce":
      return ((value / 100) * 0.5);
    case "rearDownforce":
      return ((value / 100) * 0.8);
    case "floor":
      return ((value / 100) * 0.8);
    case "suspension":
      return ((value / 100) * 0.5);
    case "engineReliability":
      return ((value / 100) * 0.2);
    case "turboReliability":
      return ((value / 100) * 0.5);
    case "energyRecovery":
      return ((value / 100) * 0.8);
    case "gearbox":
      return ((value / 100) * 0.2);
    case "weightRedistribution":
      return ((value / 100) * 0.2);
    case "weightReduction":
      return ((value / 100) * 0.5);
    case "softwareUpgrade":
      return ((value / 100) * 0.5);
    case "hardware":
      return ((value / 100) * 0.2);
    default:
      return 0; // Default value if range_name is not recognized
  }
}